import script from "./Config.vue?vue&type=script&setup=true&lang=ts"
export * from "./Config.vue?vue&type=script&setup=true&lang=ts"

import "./Config.vue?vue&type=style&index=0&id=78e2d8c8&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e2d8c8"]])

export default __exports__